// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    v1PublicGetPublicVolumeStats (params?: {}): Promise<Dict>;
    v1PublicGetPublicBrokerName (params?: {}): Promise<Dict>;
    v1PublicGetPublicChainInfoBrokerId (params?: {}): Promise<Dict>;
    v1PublicGetPublicSystemInfo (params?: {}): Promise<Dict>;
    v1PublicGetPublicVaultBalance (params?: {}): Promise<Dict>;
    v1PublicGetPublicInsurancefund (params?: {}): Promise<Dict>;
    v1PublicGetPublicChainInfo (params?: {}): Promise<Dict>;
    v1PublicGetFaucetUsdc (params?: {}): Promise<Dict>;
    v1PublicGetPublicAccount (params?: {}): Promise<Dict>;
    v1PublicGetGetAccount (params?: {}): Promise<Dict>;
    v1PublicGetRegistrationNonce (params?: {}): Promise<Dict>;
    v1PublicGetGetOrderlyKey (params?: {}): Promise<Dict>;
    v1PublicGetPublicLiquidation (params?: {}): Promise<Dict>;
    v1PublicGetPublicLiquidatedPositions (params?: {}): Promise<Dict>;
    v1PublicGetPublicConfig (params?: {}): Promise<Dict>;
    v1PublicGetPublicCampaignRanking (params?: {}): Promise<Dict>;
    v1PublicGetPublicCampaignStats (params?: {}): Promise<Dict>;
    v1PublicGetPublicCampaignUser (params?: {}): Promise<Dict>;
    v1PublicGetPublicCampaignStatsDetails (params?: {}): Promise<Dict>;
    v1PublicGetPublicCampaigns (params?: {}): Promise<Dict>;
    v1PublicGetPublicPointsLeaderboard (params?: {}): Promise<Dict>;
    v1PublicGetClientPoints (params?: {}): Promise<Dict>;
    v1PublicGetPublicPointsEpoch (params?: {}): Promise<Dict>;
    v1PublicGetPublicPointsEpochDates (params?: {}): Promise<Dict>;
    v1PublicGetPublicReferralCheckRefCode (params?: {}): Promise<Dict>;
    v1PublicGetPublicReferralVerifyRefCode (params?: {}): Promise<Dict>;
    v1PublicGetReferralAdminInfo (params?: {}): Promise<Dict>;
    v1PublicGetReferralInfo (params?: {}): Promise<Dict>;
    v1PublicGetReferralRefereeInfo (params?: {}): Promise<Dict>;
    v1PublicGetReferralRefereeRebateSummary (params?: {}): Promise<Dict>;
    v1PublicGetReferralRefereeHistory (params?: {}): Promise<Dict>;
    v1PublicGetReferralReferralHistory (params?: {}): Promise<Dict>;
    v1PublicGetReferralRebateSummary (params?: {}): Promise<Dict>;
    v1PublicGetClientDistributionHistory (params?: {}): Promise<Dict>;
    v1PublicGetTvConfig (params?: {}): Promise<Dict>;
    v1PublicGetTvHistory (params?: {}): Promise<Dict>;
    v1PublicGetTvSymbolInfo (params?: {}): Promise<Dict>;
    v1PublicGetTvKlineHistory (params?: {}): Promise<Dict>;
    v1PublicGetPublicFundingRateHistory (params?: {}): Promise<Dict>;
    v1PublicGetPublicFundingRateSymbol (params?: {}): Promise<Dict>;
    v1PublicGetPublicFundingRates (params?: {}): Promise<Dict>;
    v1PublicGetPublicInfo (params?: {}): Promise<Dict>;
    v1PublicGetPublicInfoSymbol (params?: {}): Promise<Dict>;
    v1PublicGetPublicMarketTrades (params?: {}): Promise<Dict>;
    v1PublicGetPublicToken (params?: {}): Promise<Dict>;
    v1PublicGetPublicFutures (params?: {}): Promise<Dict>;
    v1PublicGetPublicFuturesSymbol (params?: {}): Promise<Dict>;
    v1PublicPostRegisterAccount (params?: {}): Promise<Dict>;
    v1PublicPostPublicQuery (params?: {}): Promise<Dict>;
    v1PrivateGetClientKeyInfo (params?: {}): Promise<Dict>;
    v1PrivateGetClientOrderlyKeyIpRestriction (params?: {}): Promise<Dict>;
    v1PrivateGetOrderOid (params?: {}): Promise<Dict>;
    v1PrivateGetClientOrderClientOrderId (params?: {}): Promise<Dict>;
    v1PrivateGetAlgoOrderOid (params?: {}): Promise<Dict>;
    v1PrivateGetAlgoClientOrderClientOrderId (params?: {}): Promise<Dict>;
    v1PrivateGetOrders (params?: {}): Promise<Dict>;
    v1PrivateGetAlgoOrders (params?: {}): Promise<Dict>;
    v1PrivateGetTradeTid (params?: {}): Promise<Dict>;
    v1PrivateGetTrades (params?: {}): Promise<Dict>;
    v1PrivateGetOrderOidTrades (params?: {}): Promise<Dict>;
    v1PrivateGetClientLiquidatorLiquidations (params?: {}): Promise<Dict>;
    v1PrivateGetLiquidations (params?: {}): Promise<Dict>;
    v1PrivateGetAssetHistory (params?: {}): Promise<Dict>;
    v1PrivateGetClientHolding (params?: {}): Promise<Dict>;
    v1PrivateGetWithdrawNonce (params?: {}): Promise<Dict>;
    v1PrivateGetSettleNonce (params?: {}): Promise<Dict>;
    v1PrivateGetPnlSettlementHistory (params?: {}): Promise<Dict>;
    v1PrivateGetInternalTransferHistory (params?: {}): Promise<Dict>;
    v1PrivateGetVolumeUserDaily (params?: {}): Promise<Dict>;
    v1PrivateGetVolumeUserStats (params?: {}): Promise<Dict>;
    v1PrivateGetClientStatistics (params?: {}): Promise<Dict>;
    v1PrivateGetClientInfo (params?: {}): Promise<Dict>;
    v1PrivateGetClientStatisticsDaily (params?: {}): Promise<Dict>;
    v1PrivateGetPositions (params?: {}): Promise<Dict>;
    v1PrivateGetPositionSymbol (params?: {}): Promise<Dict>;
    v1PrivateGetFundingFeeHistory (params?: {}): Promise<Dict>;
    v1PrivateGetNotificationInboxNotifications (params?: {}): Promise<Dict>;
    v1PrivateGetNotificationInboxUnread (params?: {}): Promise<Dict>;
    v1PrivateGetVolumeBrokerDaily (params?: {}): Promise<Dict>;
    v1PrivateGetBrokerFeeRateDefault (params?: {}): Promise<Dict>;
    v1PrivateGetBrokerUserInfo (params?: {}): Promise<Dict>;
    v1PrivateGetBrokerDailyFeeRevenue (params?: {}): Promise<Dict>;
    v1PrivateGetOrderbookSymbol (params?: {}): Promise<Dict>;
    v1PrivateGetKline (params?: {}): Promise<Dict>;
    v1PrivateGetClientLeverages (params?: {}): Promise<Dict>;
    v1PrivateGetClientMarginModes (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelAdmin (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelAdminInfo (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelAdminRefereeList (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelAdminSummary (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelMaxRebateRate (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelRebateInfo (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelRefereeList (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelStatistics (params?: {}): Promise<Dict>;
    v1PrivateGetReferralMultiLevelVolumePrerequisite (params?: {}): Promise<Dict>;
    v1PrivatePostOrderlyKey (params?: {}): Promise<Dict>;
    v1PrivatePostClientSetOrderlyKeyIpRestriction (params?: {}): Promise<Dict>;
    v1PrivatePostClientResetOrderlyKeyIpRestriction (params?: {}): Promise<Dict>;
    v1PrivatePostOrder (params?: {}): Promise<Dict>;
    v1PrivatePostBatchOrder (params?: {}): Promise<Dict>;
    v1PrivatePostAlgoOrder (params?: {}): Promise<Dict>;
    v1PrivatePostLiquidation (params?: {}): Promise<Dict>;
    v1PrivatePostClaimInsuranceFund (params?: {}): Promise<Dict>;
    v1PrivatePostWithdrawRequest (params?: {}): Promise<Dict>;
    v1PrivatePostSettlePnl (params?: {}): Promise<Dict>;
    v1PrivatePostInternalTransfer (params?: {}): Promise<Dict>;
    v1PrivatePostNotificationInboxMarkRead (params?: {}): Promise<Dict>;
    v1PrivatePostNotificationInboxMarkReadAll (params?: {}): Promise<Dict>;
    v1PrivatePostClientLeverage (params?: {}): Promise<Dict>;
    v1PrivatePostClientLeverages (params?: {}): Promise<Dict>;
    v1PrivatePostClientMarginMode (params?: {}): Promise<Dict>;
    v1PrivatePostPositionMargin (params?: {}): Promise<Dict>;
    v1PrivatePostClientMaintenanceConfig (params?: {}): Promise<Dict>;
    v1PrivatePostDelegateSigner (params?: {}): Promise<Dict>;
    v1PrivatePostDelegateOrderlyKey (params?: {}): Promise<Dict>;
    v1PrivatePostDelegateSettlePnl (params?: {}): Promise<Dict>;
    v1PrivatePostDelegateWithdrawRequest (params?: {}): Promise<Dict>;
    v1PrivatePostBrokerFeeRateSet (params?: {}): Promise<Dict>;
    v1PrivatePostBrokerFeeRateSetDefault (params?: {}): Promise<Dict>;
    v1PrivatePostBrokerFeeRateDefault (params?: {}): Promise<Dict>;
    v1PrivatePostReferralCreate (params?: {}): Promise<Dict>;
    v1PrivatePostReferralUpdate (params?: {}): Promise<Dict>;
    v1PrivatePostReferralBind (params?: {}): Promise<Dict>;
    v1PrivatePostReferralEditSplit (params?: {}): Promise<Dict>;
    v1PrivatePostReferralEditRefereeDescription (params?: {}): Promise<Dict>;
    v1PrivatePostReferralMultiLevelAdmin (params?: {}): Promise<Dict>;
    v1PrivatePostReferralMultiLevelAdminUpdate (params?: {}): Promise<Dict>;
    v1PrivatePostReferralMultiLevelAdminCreateAffiliate (params?: {}): Promise<Dict>;
    v1PrivatePostReferralMultiLevelAdminResetAffiliate (params?: {}): Promise<Dict>;
    v1PrivatePostReferralMultiLevelAdminUpdateAffiliate (params?: {}): Promise<Dict>;
    v1PrivatePostReferralMultiLevelClaimCode (params?: {}): Promise<Dict>;
    v1PrivatePostReferralMultiLevelRebateRateSetDefault (params?: {}): Promise<Dict>;
    v1PrivatePostReferralMultiLevelRebateRateUpdate (params?: {}): Promise<Dict>;
    v1PrivatePutOrder (params?: {}): Promise<Dict>;
    v1PrivatePutAlgoOrder (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrder (params?: {}): Promise<Dict>;
    v1PrivateDeleteAlgoOrder (params?: {}): Promise<Dict>;
    v1PrivateDeleteClientOrder (params?: {}): Promise<Dict>;
    v1PrivateDeleteAlgoClientOrder (params?: {}): Promise<Dict>;
    v1PrivateDeleteAlgoOrders (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrders (params?: {}): Promise<List>;
    v1PrivateDeleteBatchOrder (params?: {}): Promise<Dict>;
    v1PrivateDeleteClientBatchOrder (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
